<template>
  <article :id="$vnode.key">
    <custom-callout
      ref="callout"
      :has-toggle="true"
      :controlled="true"
      :opened="isOpen"
      class="mt-2 mb-3"
      @click:open="toggleCallout()"
    >
      <div class="container-fluid">
        <div class="row">
          <div
            class="col-12 col-md-2 d-flex justify-content-start align-items-center"
            :class="{
              'divider-horizontal': !isMobile,
              'divider-vertical': isMobile,
            }"
          >
            <p class="font-weight-bold info-text mb-0">
              {{ value.classroomType.name }}
            </p>
          </div>
          <div class="col-12 col-md-8 pl-4">
            <div class="info-text-title">Categoría:</div>
            <p class="info-text mb-0">
              {{ value.category.name }}
            </p>
          </div>
          <div
            class="col-12 col-md-2 px-0 mt-2 mt-md-0 d-md-flex justify-content-center"
          >
            <div class="align-self-center">
              <Dropdown
                name="Actions"
                :title="'Acciones'"
                :responsive="true"
                :items="actions"
              />
            </div>
          </div>
        </div>
      </div>
      <template #edition>
        <div class="additional-container">
          <div class="p2 mt-1">
            <div class="bg-gray p-2">
              <div class="bg-white p-3 rounded pl-c-xl">
                <span class="mt-1">
                  <i class="fa fa-info-circle mr-2 color-primary-2" />
                  <span class="title color-gray-7 font-weight-bold">
                    Listado de Materiales y/o Equipos
                  </span>
                </span>
                <custom-callout
                  v-for="item in collections.searchResult"
                  :key="item.id"
                  :has-toggle="false"
                  :has-border="false"
                  class="mt-2"
                >
                  <p class="info-text mb-0 ml-n3">
                    {{ item.name }}
                  </p>
                </custom-callout>
                <CustomResultNotFound
                  v-if="showNotResults"
                  class="mt-4 row pt-3"
                  text="No cuenta información disponible."
                />
                <div class="row pt-2">
                  <div class="col-12 pt-0">
                    <Pagination
                      v-if="pagination.totalItemCount > pagination.perPage"
                      :data="pagination"
                      :page-size="pagination.perPage"
                      :parent-id="$vnode.key"
                      @pagination-go-page="requestAdditionalInfo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </custom-callout>
  </article>
</template>

<script>
import CustomCallout from 'custom-callout';
import Dropdown from 'dropdown';
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';
import { getCatalogArticleSearchResult } from '@/modules/materials-equipment/api.js';

export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    Dropdown,
    Pagination,
    CustomResultNotFound,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      loaded: false,
      collections: {
        searchResult: [],
      },
      pagination: {
        perPage: 20,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    showNotResults() {
      return this.collections.searchResult.length == 0 && this.loaded;
    },
    actions() {
      return [
        {
          icon: 'fas fa-edit text-green',
          label: 'Editar',
          click: () => this.goToEditCatalog(),
        },
        {
          icon: 'fas fa-times-circle text-red',
          label: 'Eliminar',
          click: () => this.goToDeleteCatalog(),
        },
      ];
    },
  },
  methods: {
    async toggleCallout() {
      this.isOpen = !this.isOpen;
      if (!this.isOpen || this.loaded) return;
      await this.requestAdditionalInfo();
      this.loaded = this.isOpen;
    },
    async requestAdditionalInfo(page = 1) {
      this.pagination.currentPage = page;
      const mappedFilter = {
        saloonId: this.value.classroomType?.id,
        categoryId: this.value.category?.id,
        pageIndex: page,
        pageSize: this.pagination.perPage,
      };

      await getCatalogArticleSearchResult(mappedFilter).then((res) => {
        this.collections.searchResult = res.data.data;
        this.pagination = {
          ...this.pagination,
          totalItemCount: res.data.totalItemCount,
          pageCount: res.data.pageCount,
          currentPage: res.data.currentPage,
          count: res.data.count,
        };
      });
    },
    goToEditCatalog() {
      const self = this;

      self.$router.push({
        name: 'materialEditCatalog',
        params: {
          classroomTypeId: this.value.classroomType?.id,
          categoryId: this.value.category?.id,
        },
      });
    },
    goToDeleteCatalog() {
      this.$emit('deleteCatalog', this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.info-text-title {
  color: map.get($colors, 'gray-6');
  font-size: 1rem;
  font-weight: normal;
}

.info-text {
  color: map.get($colors, 'black');
  font-weight: normal;
  font-size: 1rem;
  size: 1rem;
}

.divider-horizontal {
  border-right: 1px solid map.get($colors, 'gray-5');
}

.divider-vertical {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid map.get($colors, 'gray-5');
}
</style>
